var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "9", md: "4" } },
        [
          _c("app-ledger-account-autocomplete", {
            attrs: { fancy: "", label: _vm.$ct("code") },
            model: {
              value: _vm.inputs.code,
              callback: function ($$v) {
                _vm.$set(_vm.inputs, "code", $$v)
              },
              expression: "inputs.code",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "3", md: "1" } },
        [
          _c("w-input", {
            attrs: {
              fancy: "",
              label: _vm.$ct("vat-field"),
              value: _vm.vatField,
              disabled: "",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "9", md: "2" } },
        [
          _c("w-input-currency", {
            attrs: {
              "currency-rate": _vm.purchase.CurrencyRate,
              currency: _vm.purchase.CurrencyID,
              label: _vm.$ct("netto"),
              decimals: 2,
              fancy: "",
            },
            model: {
              value: _vm.inputs.amount,
              callback: function ($$v) {
                _vm.$set(_vm.inputs, "amount", $$v)
              },
              expression: "inputs.amount",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "3", md: "1" } },
        [
          _c("w-input-number", {
            attrs: { fancy: "", label: _vm.$ct("vat-percentage-short") },
            model: {
              value: _vm.inputs.vatPercent,
              callback: function ($$v) {
                _vm.$set(_vm.inputs, "vatPercent", $$v)
              },
              expression: "inputs.vatPercent",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "4" } },
        [
          _c(
            "w-row",
            { attrs: { "no-wrap": "" } },
            [
              _c("w-input", {
                staticClass: "mr grow",
                attrs: { fancy: "", label: _vm.$ct("comment") },
                model: {
                  value: _vm.inputs.comment,
                  callback: function ($$v) {
                    _vm.$set(_vm.inputs, "comment", $$v)
                  },
                  expression: "inputs.comment",
                },
              }),
              _vm.$wf.isMdUp
                ? _c(
                    "div",
                    { staticClass: "button-wrapper mr" },
                    [
                      _c(
                        "w-button",
                        {
                          staticClass: "danger",
                          attrs: { round: "", disabled: !_vm.showRemoveButton },
                          on: {
                            click: function ($event) {
                              return _vm.remove()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "trash" } })],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "button-wrapper" },
                [
                  _c(
                    "w-button",
                    {
                      attrs: { round: "", disabled: !_vm.isValid },
                      on: {
                        click: function ($event) {
                          return _vm.submit()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "check" } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }